module.exports = __webpack_public_path__ + "img/helpdetail4.1731c4a8.png";